export default __webpack_public_path__ + "static/media/rank1.74fdb351.png";